<template lang="pug">
v-card.flexcard
  v-card-text.grow
    paragraph-composer(v-on:input="tweet_content = arguments[0]" :stub_values='stub_values')
  v-card-actions.justify-center
    v-btn(@click='post_tweet' dark='' color='#00acee')
      img(src='https://www.gstatic.com/images/icons/material/system/2x/post_twitter_white_18dp.png')
      | Tweet
</template>

<script>
import ParagraphComposer from "./ParagraphComposer";
export default {
  components: {
    "paragraph-composer": ParagraphComposer
  },
  props: {
    stub_values: {
        type: Array,
        default: () => {return ['']}
    }
  },
  data() {
    return {
      tweet_content: "",
    };
  },
  methods: {
    post_tweet() {
      var encoded_tweet = encodeURIComponent(this.tweet_content);
      window.open(
        "https://twitter.com/intent/tweet?text=" + encoded_tweet, 'popUpWindow'
      );
    }
  }
};
</script>

